export default "__VITE_ASSET__p1IHDVpk__"